import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import StickyTable from "../../components/common/StickyTable";
import {
  CHAPTER_LIST,
  CHAPTER_DELETE,
  COUNTRY_LIST_DROPDOWN,
  STATE_LIST_DROPDOWN,
  REGION_LIST_DROPDOWN,
} from "../../routes/routes";
import { PAGINATE, CHAPTER_DELETED } from "../../constant/constant";
import { toast } from "react-toastify";
import { NoDataFound, Pagination, hasRole } from "../../components/Utils";
import Loader from "../../components/common/Loader"; // Import the loader component
import { Link, useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import { usePermission } from "../../hooks/usePermission";

const ChaptersList = () => {
  const { hasPermission } = usePermission();
  // ## State Variable Declaration
  const [data, setData] = useState([]);
  const [paginator, setPaginator] = useState({});
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [refresh, setRefresh] = useState(false);
  const [confirmation, setConfirmation] = useState({});
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [countryOptions, setCountryOptions] = useState({});
  const [stateOptions, setStateOptions] = useState({});
  const [regionOptions, setRegionOptions] = useState({});
  const [filter, setFilter] = useState([]);
  const applyFilter = (next) => {
    setPage(1);
    setFilter(next);
  };


  const chapterLaunchedOptions = [
    { value: 1, label: "Yes" },
    { value: 0, label: "No" },
  ];

  const selectStateRef = useRef(null);
  const selectRegionRef = useRef(null);

  const handleStateClear = () => {
    if (selectStateRef.current) selectStateRef.current.clearValue();
    if (selectRegionRef.current) selectRegionRef.current.clearValue();
  };

  const handleRegionClear = () => {
    if (selectRegionRef.current) selectRegionRef.current.clearValue();
  };

  /**
   * @API Chapter List API's call
   */
  const navigate = useNavigate();

  const auth_user = JSON.parse(localStorage.getItem("user"));

  const HandleDelete = async (chapterId) => {
    try {
      axios
        .delete(CHAPTER_DELETE + chapterId)
        .then((res) => {
          if (res.status === 200 && res.data.success) {
            toast.success(CHAPTER_DELETED);
            setRefresh((prevRefresh) => !prevRefresh);
            navigate("/chapters");
          }
        })
        .catch((err) => {
          if (err.response.status === 422) {
            toast.error(err.response.data.msg);
          }
        });
    } catch (error) {
      // Handle errors
      console.error(error);
    }
  };

  useEffect(() => {
    axios
      .get(CHAPTER_LIST, {
        params: {
          type: PAGINATE,
          page: page,
          perPage: perPage,
          ...filter,
        },
      })
      .then((response) => {
        if (response.status === 200 && response.data.success) {
          setData(response.data.data.chapters);
          setPaginator({
            prev: response.data.data.prev_page_url != null,
            next: response.data.data.next_page_url != null,
            total: response.data.data.total,
            current: response.data.data.current_page,
            last: response.data.data.last_page,
          });
        }
      })
      .finally(() => {
        setLoading(false); // Set loading to false after data is fetched
      });

    const fetchData = async () => {
      try {
        // Fetch country data
        const countryResponse = await axios.get(COUNTRY_LIST_DROPDOWN);
        const fetchedCountryOptions = countryResponse.data.data;
        setCountryOptions(fetchedCountryOptions);

        // Fetch state data
        const stateResponse = await axios.get(STATE_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedStateOptions = stateResponse.data.data;
        setStateOptions(fetchedStateOptions);

        // Fetch region data
        const regionResponse = await axios.get(REGION_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedRegionOptions = regionResponse.data.data;
        setRegionOptions(fetchedRegionOptions);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [page, filter, perPage, refresh]);
  return (
    <div className="content-wrapper icontent-wrapper">
      <div className="container-fluid p-0 mt-0 mb-2">
        <div className="col-lg-12">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h5 className="page-title">Chapters</h5>
              <ol className="breadcrumb">
                <li>
                  <div className="breadcrumb_f">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="50"
                        height="50"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#212b39"
                        strokeWidth="1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                      </svg>
                    </div>
                    <div>
                      <Link to={"/dashboard"}>
                        <span>Dashboard</span>
                      </Link>
                    </div>
                  </div>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#212b39"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </li>
                <li>
                  <span className="active_breadcrumb">Chapters List</span>
                </li>
              </ol>
            </div>
            <div className="col-lg-6">
              <div className="pt-btn">
                {hasPermission("chapters-create") && (
                  <Link to={"/create/chapter"}>
                    <button
                      type="button"
                      className="btn rounded-pill btn-primary ibutton"
                    >
                      <span className="tf-icons bx bx-plus"></span>&nbsp; Add
                    </button>
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex-grow-1">
        <div className="card icard sticky-table-card">
          {/* <div className="card-header">
            <h5>Chapters List</h5>
          </div> */}

          {/* Filters */}
          <div className="container-fluid f_containter">
            <div className="row mb-2">
              {hasRole([1]) && (
                <div className="col-md-3">
                  <div className="mb-3">
                    <label className="form-label" htmlFor="country_id">
                      Country
                    </label>
                    <Select
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      name="country_id"
                      isClearable
                      options={countryOptions}
                      onChange={(selected) => {
                        handleStateClear();
                        applyFilter({
                          ...filter,
                          country_id: selected?.value,
                          state_id: null,
                          region_id: null,
                        });
                      }}
                    />
                  </div>
                </div>
              )}

              {hasRole([1, 6]) && (
                <div className="col-md-3">
                  <div className="mb-3">
                    <label className="form-label" htmlFor="state_id">
                      State
                    </label>
                    <Select
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      ref={selectStateRef}
                      name="state_id"
                      isClearable
                      options={stateOptions}
                      onChange={(selected) => {
                        handleRegionClear();
                        applyFilter({
                          ...filter,
                          state_id: selected?.value,
                          region_id: null,
                        });
                      }}
                    />
                  </div>
                </div>
              )}

              {hasRole([1, 6, 7]) && (
                <div className="col-md-3">
                  <div className="mb-3">
                    <label className="form-label" htmlFor="region_id">
                      Region
                    </label>
                    <Select
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      ref={selectRegionRef}
                      name="region_id"
                      isClearable
                      options={regionOptions}
                      onChange={(selected) => {
                        applyFilter({
                          ...filter,
                          region_id: selected?.value,
                        });
                      }}
                    />
                  </div>
                </div>
              )}

              <div className="col-md-3">
                <div className="mb-3">
                  <label className="form-label" htmlFor="is_chapter_launched">
                    Is Chapter Launched
                  </label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    name="is_chapter_launched"
                    isClearable
                    placeholder="Select"
                    options={chapterLaunchedOptions}
                    onChange={(selected) => {
                      applyFilter({
                        ...filter,
                        is_chapter_launched:
                          selected !== null && selected !== undefined
                            ? selected.value
                            : undefined,
                      });
                    }}
                  />
                </div>
              </div>

              <div className="col-md-3">
                <div className="mb-3">
                  <label className="form-label" htmlFor="search">
                    Search
                  </label>
                  <input
                    type="text"
                    className="form-control hide-arrow"
                    id="search"
                    placeholder="Search by Chapter Name"
                    onChange={(e) =>
                      applyFilter({ ...filter, search: e.target.value })
                    }
                  />
                </div>
              </div>
            </div>
          </div>
          {/* Filters */}

          {/* Pagination Component */}
          {data.length > 0 && (
            <Pagination
              paginator={paginator}
              page={(no) => setPage(no)}
              perPage={perPage}
              setPerPage={setPerPage}
            />
          )}

          <StickyTable refreshDeps={[data, loading]}><table className="table table-striped itable sticky-action-col">
              <thead>
                <tr>
                  <th>Sl. No.</th>
                  {hasRole([1]) && <th>Country</th>}
                  {hasRole([1, 6]) && <th>State</th>}
                  {hasRole([1, 6, 7]) && <th>Region</th>}
                  <th>Chapter Name</th>
                  {/* <th>Chapter Address</th> */}
                  <th>Weekly Meeting Day</th>
                  {/* <th>Meeting Frequency</th>
                  <th>Meeting Weeks</th> */}
                  <th>Weekly Meeting Time</th>
                  <th>Weekly Meeting Fees</th>
                  <th>Launching Date</th>
                  <th>Is Chapter Launched</th>
                  <th>Background Color</th>
                  <th>Color</th>
                  <th style={{ textAlign: "center", width: "10%" }}>Action</th>
                </tr>
              </thead>
              <tbody className="table-border-bottom-0">
                {loading ? (
                  <Loader loading={loading} colspan="13" />
                ) : data.length > 0 ? (
                  data.map((chapter, i) => (
                    <tr key={i}>
                      <td>{chapter?.sno}</td>
                      {hasRole([1]) && <td>{chapter?.country_name}</td>}
                      {hasRole([1, 6]) && <td>{chapter?.state_name || "Tamil Nadu"}</td>}
                      {hasRole([1, 6, 7]) && <td>{chapter?.region_name}</td>}
                      <td>{chapter?.chapter_name}</td>
                      {/* <td>{WrapText(chapter?.address, 60)}</td> */}
                      <td>{chapter?.weekly_meeting_days_in_text}</td>
                      {/* <td>{chapter?.meeting_frequency_in_text}</td>
                      <td>{chapter?.meeting_weeks}</td> */}
                      <td>{chapter?.weekly_meeting_time}</td>
                      <td>{chapter?.weekly_meeting_fees}</td>
                      <td>{chapter?.launching_date}</td>
                      <td>{chapter?.is_chapter_launched_text}</td>
                      <td>
                        <span
                          className="chapterbadge"
                          style={{ backgroundColor: chapter?.background_color }}
                        ></span>
                      </td>
                      <td>
                        <span
                          className="chapterbadge"
                          style={{ backgroundColor: chapter?.color }}
                        ></span>
                      </td>
                      <td style={{ textAlign: "right" }}>
                        {hasPermission("chapters-edit") && (
                          <Link to={`/chapter/${chapter.id}/edit`}>
                            <button
                              onClick={() => {
                                setConfirmationModal(true);
                                setConfirmation({
                                  message: "Are you sure, you want to delete?",
                                  fn: () => HandleDelete(chapter?.id),
                                });
                              }}
                              className="badge bg-label-success me-1 border-0"
                              data-bs-toggle="tooltip"
                              data-bs-offset="0,4"
                              data-bs-placement="top"
                              data-bs-html="true"
                              title="Edit"
                              data-bs-original-title="Edit"
                            >
                              <i className="bx bx-pencil"></i>
                            </button>
                          </Link>
                        )}
                        {/* {hasPermission("chapters-delete") && (
                          <button
                            onClick={() => {
                              setConfirmationModal(true);
                              setConfirmation({
                                message: "Are you sure, you want to delete?",
                                fn: () => HandleDelete(chapter?.id),
                              });
                            }}
                            className="badge bg-label-danger me-1 border-0"
                            data-bs-toggle="tooltip"
                            data-bs-offset="0,4"
                            data-bs-placement="top"
                            data-bs-html="true"
                            title="Delete"
                            data-bs-original-title="Delete"
                          >
                            <i className="bx bx-trash"></i>
                          </button>
                        )} */}
                      </td>
                      {/* <td>{chapter?.chapter_name}</td>
                    
                      <td>{WrapText(chapter?.address,40)}</td>
                      <td>{chapter?.weekly_meeting_days_in_text}</td> */}
                    </tr>
                  ))
                ) : (
                  <NoDataFound colspan="13" message="No Data Found" />
                )}
              </tbody>
            </table>
          </StickyTable>
          {/* Pagination Component */}
          {data.length > 0 && (
            <Pagination
              paginator={paginator}
              page={(no) => setPage(no)}
              perPage={perPage}
              setPerPage={setPerPage}
            />
          )}
        </div>
      </div>

      <Modal
        show={confirmationModal}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => setConfirmationModal(false)}
        backdrop="static"
      >
        <Modal.Header closeButton className="no-border"></Modal.Header>
        <Modal.Body className="idel_popup">
          <div className="icon_holder">
            <div className="pop_del_icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="50"
                height="50"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#1A4331"
                strokeWidth="1"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="3 6 5 6 21 6"></polyline>
                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                <line x1="10" y1="11" x2="10" y2="17"></line>
                <line x1="14" y1="11" x2="14" y2="17"></line>
              </svg>
            </div>
          </div>
          <h6 className="text-center modal_title">{confirmation?.message}</h6>
          <div className="text-center">
            <button
              onClick={() => {
                setConfirmationModal(false);
                setConfirmation({});
              }}
              className="btn btn-danger btn-sm me-2 iclose_btn"
            >
              No
            </button>
            <button
              onClick={() => {
                confirmation.fn();
                setConfirmationModal(false);
                setConfirmation({});
              }}
              className="btn btn-success btn-sm isubmit_button"
            >
              Yes
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ChaptersList;
